import { onMounted, ref } from '@vue/composition-api';
import provider from '@/api/apollo-client';
import useAuth from '@/api/auth';
export default function(schemas, filters) {
  const { profile } = useAuth();
  const list = ref([]);
  const fields = ref([]);
  const visibleFields = ref([]);
  const loading = ref(true);
  const saving = ref(false);
  const total = ref(0);

  const params = ref({
    filter: null,
    first: 10,
    offset: 0,
    orderBy: 'NATURAL'
  });

  // init global filter
  if (filters) {
    const filterKeys = Object.keys(filters);
    filterKeys.forEach(i => {
      if (!params.value.filter) {
        params.value.filter = {};
      }
      if (i === 'userGroups') {
        params.value.filter[i] = { contains: filters[i] };
      } else {
        params.value.filter[i] = { equalTo: filters[i] };
      }
    });
  }

  function setParams(data) {
    if (data === null) {
      params.value = {
        filter: null,
        first: 10,
        offset: 0,
        orderBy: 'NATURAL'
      };
    } else {
      params.value = { ...params.value, ...data };
    }
  }

  async function load() {
    loading.value = true;
    // TODO: need remove this block and fix broken notifications after
    if (schemas.loadTranslations) {
      await provider
        .query({
          query: schemas.loadTranslations
        })
        .then(r => {
          fields.value = r.data.translations.map(i => ({
            field: i.key,
            value: i.key,
            key: i.key,
            text: i.en
          }));
          visibleFields.value = fields.value.map(i => i.key);
        });
    }
    if (params.value.filter === null) {
      delete params.value.filter;
    }
    return provider
      .query({
        query: schemas.load,
        fetchPolicy: 'no-cache',
        variables: {
          ...params.value
        }
      })
      .then(r => {
        const keys = Object.keys(r.data);
        if (keys.length && r.data[keys[0]].totalCount >= 0) {
          list.value = r.data[keys[0]].edges.map(i => i.node);
          total.value = r.data[keys[0]].totalCount;
        }
        return r.data;
      })
      .finally(() => {
        loading.value = false;
      });
  }

  function save(data) {
    saving.value = true;
    return provider
      .mutate({
        mutation: schemas.save,
        variables: {
          input: { ...data }
        }
      })
      .finally(() => {
        saving.value = false;
      });
  }

  function remove(items) {
    loading.value = true;
    return provider
      .mutate({
        mutation: schemas.remove,
        variables: {
          input: { mnPatch: items }
        }
      })
      .finally(() => {
        loading.value = false;
      });
  }

  function update(items) {
    loading.value = true;
    return provider
      .mutate({
        mutation: schemas.update,
        variables: {
          input: { mnPatch: items }
        }
      })
      .finally(() => {
        loading.value = false;
      });
  }

  return {
    visibleFields,
    remove,
    fields,
    params,
    setParams,
    loading,
    saving,
    list,
    load,
    save,
    total,
    update
  };
}
